import { Injectable, signal, WritableSignal } from '@angular/core';
import { ExamType } from '@tsin-core/entities';

export interface IMenu {
    url: string;
    label: string;
    icon: string;
}

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    // declare a signal variable called recruitMode
    private toggle: WritableSignal<boolean> = signal(false);

    private menus: IMenu[] = [];

    // write a setter function for the signal type
    toggleMenu(value: boolean): void {
        this.toggle.set(value);
    }

    // write a getter function for the signal type
    getToggleState(): boolean {
        return this.toggle();
    }

    // write a direct getter variable for the signal type
    public readonly visible = this.toggle;
}
